import { render, staticRenderFns } from "./DepartmentTransfer.vue?vue&type=template&id=f4d9a34e&"
import script from "./DepartmentTransfer.vue?vue&type=script&lang=ts&"
export * from "./DepartmentTransfer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports